import { render, staticRenderFns } from "./AttachmentComponent.vue?vue&type=template&id=ec541096&scoped=true&"
import script from "./AttachmentComponent.vue?vue&type=script&lang=js&"
export * from "./AttachmentComponent.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentComponent.vue?vue&type=style&index=0&id=ec541096&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec541096",
  null
  
)

export default component.exports